import {
  WSCard,
  WSElement,
  WSSectionToolbar
} from "@wingspanhq/fe-component-library";
import { formatMoney } from "@wingspanhq/utils/dist/formatMoney";
import { PayStatementEarning } from "@wingspanhq/wingspan-api-sdk";
import React from "react";

import { PAYROLL_CURRENCY } from "../../constants";
import { parsePayrollAmount } from "../../utils";
import {
  StatementColumn,
  StatementRow,
  StatementTable
} from "../StatementTable";

const INCOME_COLUMNS: StatementColumn[] = [
  { span: "4" },
  { span: "2", align: "end" },
  { span: "2", align: "end" },
  { span: "2", align: "end" },
  { span: "2", align: "end" }
];

/**
 * v3 models an earning by its wage `type` (e.g. "Hourly"); there is no
 * per-line label on the statement.
 */
const selectEarningLabel = (earning: PayStatementEarning): string =>
  earning.type ? `${earning.type}` : "Earnings";

type Props = {
  earnings: PayStatementEarning[];
  grossPayThisPeriod: number;
  grossPayYearToDate: number;
};

export const PaystubIncomeCard: React.FC<Props> = ({
  earnings,
  grossPayThisPeriod,
  grossPayYearToDate
}) => {
  const rows: StatementRow[] = [
    {
      id: "header",
      variant: "header",
      cells: ["Earnings", "Rate", "Hours", "This period", "Year to date"]
    },
    ...earnings.map((line, index) => ({
      id: `earning-${index}`,
      variant: "item" as const,
      cells: [
        selectEarningLabel(line),
        line.rate == null ? "" : formatMoney(line.rate, PAYROLL_CURRENCY),
        line.hours == null ? "" : line.hours.toFixed(2),
        formatMoney(parsePayrollAmount(line.amount), PAYROLL_CURRENCY),
        // v3 exposes YTD only for the statement as a whole (`amountDetails.ytd`),
        // never per earning line — so the per-line column stays at zero.
        formatMoney(0, PAYROLL_CURRENCY)
      ]
    })),
    {
      id: "gross-pay",
      variant: "subtotal",
      cells: [
        "Gross pay",
        "",
        "",
        formatMoney(grossPayThisPeriod, PAYROLL_CURRENCY),
        formatMoney(grossPayYearToDate, PAYROLL_CURRENCY)
      ]
    }
  ];

  return (
    <WSElement>
      <WSSectionToolbar title="Income" />
      <WSCard mt="M">
        <StatementTable columns={INCOME_COLUMNS} rows={rows} />
      </WSCard>
    </WSElement>
  );
};
